import React, { createContext, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createDesignStore } from './index';
import { devToolsEnabled } from '../../utils/state-utils';

const DesignStoreContext = createContext(null);

export const DesignStoreProvider = ({ uniqueId, children }) => {
  const storeRef = useRef();

  if (!storeRef.current) {
    storeRef.current = create(
      devtools(
        createDesignStore(uniqueId),
        { enabled: devToolsEnabled, store: 'DESIGN', name: `[DESIGNER] DESIGN ${uniqueId}` }
      )
    );
  }
  return (
    <DesignStoreContext.Provider value={storeRef.current}>
      {children}
    </DesignStoreContext.Provider>
  );
};

DesignStoreProvider.propTypes = {
  uniqueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node
};

DesignStoreProvider.defaultProps = {
  children: null
};

export const useDesignStore = (selector) => {
  const store = useContext(DesignStoreContext);
  if (!store) throw new Error('useDesignStore must be used within DesignStoreProvider');
  return store(selector);
};
